function is_pc(){
  if(window.innerWidth > 799){
    IS_PC = true;
    return true;
  }else{
    IS_PC = false;
    return false;
  }
}
function is_sp(){
  if(window.innerWidth <= 799){
    IS_SP = true;
    return true;
  }else{
    IS_SP = false;
    return false;
  }
}

// ロード
$(window).on('load', function (){
  $('#loading').fadeOut(800);
});

$(function(){

  // Scrollbar.js
  const $mcs = $(".scroll-area");
  if($mcs.length){
    $(".scroll-area").mCustomScrollbar({
      theme: "minimal-dark",
      axis: "y",
      autoDraggerLength: false,
      autoHideScrollbar: true,
      autoExpandScrollbar: false,
      scrollInertia: 600,
    });
  }

  // モーダル
  var $modal_bg = $(".js-modal-bg");
  $(".js-modal").click(function(e){
    if($(e.target).hasClass("js-modal")){
      $(this).fadeOut();
      $modal_bg.removeClass("-bg");
    }
  });
  $(".js-modal-open").click(function(){
    
    var modal = $(this).data("modal");
    var $modal = $(`#${modal}`);
    $modal.fadeIn();
    $modal_bg.addClass("-bg");

    var $slide = $modal.find(".js-slide-products:not(.slick-initialized)");
    if($slide.length){
      $slide.on("init", function(event, slick){
        if(slick.slideCount === 1) $(this).find(".slick-dots").hide();
      });
      $slide.slick({infinite: true, arrows: true, dots: true});
    }
  });
  $(".js-modal-close").click(function(){
    var $modal = $(this).closest(".js-modal");
    $modal.fadeOut();
    $modal_bg.removeClass("-bg");
  });

  // アコーデイオンボタン
  $('.js-ac').on('click', function() {
    $(this).toggleClass('-active');
    $(this).next('.js-ac-content').slideToggle(300);
  });

  // inview
  $(".--inview").each(function(){
	  ScrollTrigger.create({
	      trigger: $(this),
	      start: "top 95%",
	      end: "bottom 0%",
	      toggleClass: {
	          targets: $(this),
	          className: "-active",
	      },
	      once: true,
        // markers: true,
	  });
	});

  // パララックス
  $(".--img-para").each(function(item){
    var $img = $(this).find("img");
    if(!$img.length) $img = $(this).find(".canvas");
    gsap.fromTo(
      $img,
      {
        yPercent: 0,
      },
      {
        yPercent: 30,
        ease: "none",
        // ease: "power1.out",
        scrollTrigger: {
          trigger: $(this),
          start: "top bottom",
          end: "bottom top",
          scrub: 0.5,
        },
      }
    );
  });
  $(".--img-para-s").each(function(item){
    var $img = $(this).find("img");
    if(!$img.length) $img = $(this).find(".canvas");
    gsap.fromTo(
      $img,
      {
        yPercent: 0,
      },
      {
        yPercent: 10,
        ease: "none",
        // ease: "power1.out",
        scrollTrigger: {
          trigger: $(this),
          start: "top bottom",
          end: "bottom top",
          scrub: 0.5,
        },
      }
    );
  });

  // トップページ/代表事例
  const $case = $(".js-case-box");
  const $case_num = $(".js-case-num");
  const $case_logo = $case.find(".logo img");
  const $case_images = $case.find(".images");
  var case_1 = false;
  var case_2 = false;
  var case_3 = false;
  ScrollTrigger.create({
    // nullTargetWarn: false,
    trigger: $case,
    start: "top top",
    end: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;

      switch (true) {
        case progress < 3 / 10:
          if(!case_1) {
            case_1 = true;
            setCase(1);
          }
          case_2 = false;
          case_3 = false;
          break;

        case progress < 8 / 10:
          if(!case_2) {
            case_2 = true;
            setCase(2);
          }
          case_1 = false;
          case_3 = false;
          break;
      
        default:
          if(!case_3) {
            case_3 = true;
            setCase(3);
          }
          case_1 = false;
          case_2 = false;
          break;
      }
    }
  });
  function setCase(n){
    $case_num.text(('00' + n).slice(-2));
    $case_logo.css('opacity', 0);
    $case_logo.eq(n-1).css('opacity', 1);
  }

  gsap.to(
    $case_images,
    {
      y: $case_images.height() - $case_images.find('img:first-child').height(),
      ease: "none",
      scrollTrigger: {
        trigger: $case,
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      }
    }
  );
  gsap.fromTo(
    $case_images.find("img"),
    {
      yPercent: 0,
    },
    {
      yPercent: 10,
      ease: "none",
      // ease: "power1.out",
      scrollTrigger: {
        trigger: $case,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5,
      },
    }
  );

  // トップページ/ギネスセクション
  const $guinness = $("#_guinness .sec-pin");
  const $guinness_bg = $("#_guinness .sec-bg");
  const $guinness_col = $guinness_bg.find(".column:not(.-reverse)");
  const $guinness_col_r = $guinness_bg.find(".column.-reverse");
  const $collaboration = $("#_collaboration");

  $guinness.each(function(){
    ScrollTrigger.create({
      trigger: $(this),
      start: "top top",
      end: "bottom bottom",
      pin: true,
      pinSpacing: false,
      // scrub: 0.5,
    });
	  // ScrollTrigger.create({
    //   trigger: $(this),
    //   start: "top top-=100",
    //   toggleClass: {
    //     targets: $(this).find(".sec-inner"),
    //     className: "-active",
    //   },
    //   once: false,
    //   markers: true,
	  // });
    const tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: $collaboration,
        start: "bottom 60%",
        end: "bottom top",
        scrub: 0.5,
        // markers: true,
      }
    })
    .to($collaboration.find(".sec-bg"), { opacity: .75, ease: "none" }, 0)
    .to($guinness_bg.find(".cover"), { opacity: .75, ease: "none" }, 0)
    .to($collaboration.find(".sec-inner"), { opacity: 0, ease: "none" }, 0);
    gsap.timeline({
      scrollTrigger: {
        trigger: $guinness,
        start: "top top",
        end: "+=300",
        scrub: 0.5,
        // markers: true,

        onLeave:     () => $(this).find(".sec-inner").addClass("-active"),    // フェード完了(+=300)で表示
        onEnterBack: () => $(this).find(".sec-inner").removeClass("-active"), // 戻したら消す
      }
    })
    .to($guinness_bg.find(".image"), { opacity: 1, duration: 1 }, 0);
  });
  $guinness_bg.each(function(){
    gsap.from(
      $(this),
      {
        scale: 1.8,
        // force3D: false,
        ease: "none",
        // ease: "power1.out",
        scrollTrigger: {
          trigger: $guinness,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.5,
        }
      }
    );
  });
  $guinness_col.each(function(){
    gsap.to(
      $(this),
      {
        yPercent: -100 * 2 / 3,
        // scale: 1,
        opacity: 1,
        ease: "none",
        force3D: true,
        scrollTrigger: {
          trigger: $guinness,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.5,
        }
      }
    );
  });
  $guinness_col_r.each(function(){
    gsap.from(
      $(this),
      {
        yPercent: -100,
        // scale: 1.2,
        opacity: .2,
        ease: "none",
        force3D: true,
        scrollTrigger: {
          trigger: $guinness,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.5,
        }
      }
    );
  });

  const $sidebtn = $("#sidebtn .btn");
  const $sidebtn_b = $sidebtn.eq(0);
  const $sidebtn_w = $sidebtn.eq(1);
  const $pagetop = $(".page_top")
  $(".js-sideadjust-b").each(function(){
	  gsap.to($(this), {
      scrollTrigger: {
	      trigger: $(this),
	      start: "top 130px",
        end: "bottom 230px",
	      toggleClass: {
          targets: $sidebtn_b,
          className: "-gray",
	      },
	      once: false,
        // markers: true,
      }
	  });
  });
  $(".js-sideadjust-w").each(function(){
	  gsap.to($(this), {
      scrollTrigger: {
	      trigger: $(this),
	      start: "top 230px",
        end: "bottom 330px",
	      toggleClass: {
          targets: $sidebtn_w,
          className: "-white",
	      },
	      once: false,
        // markers: true,
      }
	  });
  });

  $(".js-sideadjust-w").each(function(){
	  gsap.to($(this), {
      scrollTrigger: {
	      trigger: $(this),
        start: "top bottom-=100",
        end: "bottom bottom-=100",
	      toggleClass: {
          targets: $pagetop,
          className: "-black",
	      },
	      once: false,
        // markers: true,
      }
	  });
  });

  ScrollTrigger.create({
    trigger: ".oem-top #_fv",
    start: "bottom 20%",
    end: "max",
    toggleClass: {
      targets: $pagetop,
      className: "active",
    },
    once: false,
    // markers: true,
  });

  ScrollTrigger.create({
    trigger: ".sec-list",
    start: "top top",
    end: "max",
    toggleClass: {
      targets: $pagetop,
      className: "active",
    },
    // markers: true,
  });
});

$(function(){

  const $canvas = $(".js-image-canvas");
  var dataset = {};

  $canvas.each(function(I){
    const canvas = $(this).find("canvas")[0];
    const ctx = canvas.getContext('2d');
    const wrapper = $(this)[0];
    var imageSrc = $(this).data("src");
    var imageSrcSp = $(this).data("src-sp");
    if(is_sp() && imageSrcSp) imageSrc = imageSrcSp; 
    const img = new Image();
    img.src = imageSrc;
    canvas.width = wrapper.clientWidth;
    canvas.height = wrapper.clientHeight;
    let lines = [];
    const totalLines = canvas.width * 5; // 縦線の総数

    // マスクを保存しておくための裏キャンバス
    const maskCanvas = document.createElement('canvas');
    maskCanvas.width = canvas.width;
    maskCanvas.height = canvas.height;
    const maskCtx = maskCanvas.getContext('2d');

    dataset[Number(I)] = {
      canvas: canvas,
      ctx: ctx,
      img: img,
      lines: lines,
      totalLines: totalLines,
      currentLine: 0,
      animationActive: false,
      maskCanvas: maskCanvas,
      maskCtx: maskCtx,
      inview: false,
    };

    // 画像の読み込みが完了したら初期化
    img.onload = function() {
      for (let i = 0; i < totalLines; i++) {
        lines.push(new RevealLine(I));
      }
      dataset[I].lines = lines;

      $(window).on("scroll", function() {
        if($(window).scrollTop() + $(window).height() * 0.8 > $(canvas).offset().top){
          if(!dataset[I].inview){
            dataset[I].inview = true;
            dataset[I].animationActive = true;
            animate(I);
          }
        }
      });
    };

  });

  // 縦線のクラス
  class RevealLine {
      constructor(I) {
          this.width = dataset[I].canvas.width / dataset[I].totalLines;
          this.height = dataset[I].canvas.height * 1.5;
          this.x = (dataset[I].currentLine++) * this.width;
          this.y = dataset[I].canvas.height * 1.5; 
          
          // 上昇スピード
          this.speedY = Math.random() * 4 + dataset[I].canvas.height/50;
          
          // 出現のタイミングをずらすディレイ（フレーム数）
          this.delay = Math.random() * 5;
          
          // この線が完全に通り過ぎたか
          this.isDone = false;
      }
      update(I) {
          if (this.delay > 0) {
              this.delay--;
              return;
          }
          // 下から上へ上昇
          this.y -= this.speedY;
          this.speedY += 0.2;

          // 線の「下端」が画面最上部を通り抜けたら終了
          if (this.y < -this.height) {
              this.isDone = true;
          }
      }
      // 1. マスクを描画
      drawMask(I) {
          if (this.delay > 0) return;
          
          // 線の「下端（お尻）」が通過した部分＝（現在のy + height）から画面最下部までを塗りつぶす
          let currentBottom = this.y + this.height;
          if (currentBottom < dataset[I].canvas.height) {
              dataset[I].maskCtx.fillStyle = 'rgba(255, 255, 255, 1)';
              dataset[I].maskCtx.fillRect(this.x, currentBottom, this.width, dataset[I].canvas.height - currentBottom);
          }
      }
      // 2. 白い線を描画
      drawWhiteLine(I) {
          if (this.delay > 0 || this.isDone) return;
          
          // 少し光らせるために透明度をランダムに
          dataset[I].ctx.fillStyle = `rgba(255, 255, 255, 0.1)`;
          dataset[I].ctx.fillRect(this.x, this.y, this.width, this.height);
      }
  }

  function animate(I) {
      if (!dataset[I]) return;
      if (!dataset[I].animationActive) return;
      
      // 1. メイン画面をクリア
      dataset[I].ctx.clearRect(0, 0, dataset[I].canvas.width, dataset[I].canvas.height);

      // 2. すべての線の状態を更新
      let allDone = true;
      for (let i = 0; i < dataset[I].lines.length; i++) {
          dataset[I].lines[i].update(I);
          if (!dataset[I].lines[i].isDone) allDone = false;
      }

      // 3. 裏キャンバス（マスク）に、線が通過したルートを上書き記録していく
      for (let i = 0; i < dataset[I].lines.length; i++) {
        dataset[I].lines[i].drawMask(I);
      }

      // 4. メイン画面に「通過したルートの形」の画像を描画する
      dataset[I].ctx.save();
      // 裏のマスク画像をメイン画面に描く
      dataset[I].ctx.drawImage(dataset[I].maskCanvas, 0, 0, dataset[I].canvas.width, dataset[I].canvas.height);

      // 「次に描くもの（画像）を、今描かれている不透明な部分にだけ残す」ブレンドモードに設定
      dataset[I].ctx.globalCompositeOperation = 'source-in';
      // 画像を描画
      dataset[I].ctx.drawImage(dataset[I].img, 0, 0, dataset[I].canvas.width, dataset[I].canvas.height);
      dataset[I].ctx.restore();

      // 5. 白い線を重ねて描画する（ブレンドモードは通常に戻る）
      for (let i = 0; i < dataset[I].lines.length; i++) {
        dataset[I].lines[i].drawWhiteLine(I);
      }

      // 全て完了したらループを停止して画像を完全表示のまま固定
      if (allDone) {
          dataset[I].animationActive = false;
          dataset[I].ctx.drawImage(dataset[I].img, 0, 0, dataset[I].canvas.width, dataset[I].canvas.height);
      } else {
        requestAnimationFrame(() => animate(I));
      }
  }
});

// ページ内リンク
$(function(){
  var speed = 500;
  const $header = $("#header");
  const hash = location.hash;
  const $target = $(hash);

  if($target.length){
    var position = $target.offset().top;
    if($target.hasClass("js-anchor-space")) position -= $header.outerHeight();
    if(position < 0) position = 0;
    $("html, body").animate({scrollTop:position}, speed, "swing");
  }

  $('a[href*="#"]').click(function(){
    var href= $(this).prop('hash');
    var $target = $(href == "#" || href == "" ? 'html' : href);
    if(!$target.length) return;
    var position = $target.offset().top;
    if($target.hasClass("js-anchor-space")) position -= $header.outerHeight();
    if(position < 0) position = 0;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    // return false;
  });
});


